/**
 * Éditeur de type "select" — affiche des options sous forme de boutons radio visuels.
 * Utilisé pour les champs à valeurs prédéfinies (ex: imagePosition: left/right).
 *
 * Props :
 *   value   — valeur courante
 *   options — [{ value, label, icon? }]
 *   onSave  — callback(newValue)
 *   onClose — callback()
 */
export const SelectEditor = ({ value, options = [], onSave, onClose }) => {
  return (
    <div className="flex flex-col gap-2">
      {options.map(opt => (
        <button
          key={opt.value}
          onClick={() => { onSave(opt.value); onClose() }}
          className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg border text-sm text-left transition-all ${
            value === opt.value
              ? 'border-teal-600 bg-teal-50 text-teal-800 font-medium'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-gray-700'
          }`}
        >
          {opt.icon && (
            <span className="flex-shrink-0 text-current opacity-70">{opt.icon}</span>
          )}
          <span className="flex-1">{opt.label}</span>
          {value === opt.value && (
            <span className="flex-shrink-0 w-2 h-2 rounded-full bg-teal-600" />
          )}
        </button>
      ))}
    </div>
  )
}
